import Raven from 'raven-js';

export function captureException(error) {
  if (process.env.NODE_ENV !== 'development') {
    Raven.captureException(error);
  }

  console.error(error);
}
